export const chain = fn => {
	let prev = null;
	let count = 0;

	return (...args) =>
		new Promise((resolve, reject) => {
			count += 1;
			const task = () => fn(...args).then(resolve, reject);

			prev = prev != null ? prev.finally(task) : task();

			return prev.finally(() => {
				count -= 1;
				if (count === 0) prev = null;
			});
		});
};

export const chainResults = fn => {
	let prev = null;
	return (...args) => {
		prev = Promise.all([fn(...args), prev]);
		return prev.then(res => res[0]);
	};
};

export const debounce = (fn, wait) => {
	let timerId = null;
	const resetTimer = () => {
		timerId = null;
	};
	return (...args) =>
		new Promise((resolve, reject) => {
			if (timerId != null) clearTimeout(timerId);

			timerId = setTimeout(
				() =>
					fn(...args)
						.then(resolve, reject)
						.finally(resetTimer),
				wait,
			);
		});
};
